<script setup>
import TiptapToolbarBtn from "./TiptapToolbarBtn.vue"

const props = defineProps({
    editor: {
        type: Object,
        required: true
    }
})

const emit = defineEmits(['open-image-modal'])
</script>

<template>
    <TiptapToolbarBtn
        :iconClass="'bi-image'"
        :command="() => { emit('open-image-modal') }"
        :is-active="editor.isActive('image')"
    />
</template>